<template>
	<el-dialog :title="title" :close-on-click-modal="false" :visible.sync="subVisible" width="922px">
		<el-table :row-style="selectRowBackground" :row-class-name="tableRowClassName" ref="dataListTable"
			:header-cell-style="headClass" class="dataListTable" :data="dataList" header-align="center"
			header-cell-class-name="dataListTHeader" @selection-change="handleSelectionChange"
			:cell-style="{ padding: '0px' }" style="margin-bottom: 20px;">
			<el-table-column type="selection" width="45" align="center"></el-table-column>
			<el-table-column label="No." width="70" align="center">
				<template slot-scope="scope">
					{{ (pageIndex2 - 1) * pageSize + scope.$index + 1 }}
				</template>
			</el-table-column>
			<el-table-column prop="fileNo" label="编号" align="left" min-width="150">
			</el-table-column>
			<el-table-column prop="weeklyContactDesc" label="内容" align="left" min-width="250">
			</el-table-column>
		</el-table>
		<el-pagination class="my-pagination" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
			:current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
			layout="total, sizes, prev, pager, next, jumper">
		</el-pagination>
		<el-row class="formBtnGroup">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()"
					:disabled="disabledSaved">保存</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "choose-progress-record",
	data() {
		return {
			subVisible: false,
			disabledSaved: true,
			progressKindId: '',
			progressKindName: '',
			tableSelVals: [],
			dataList: [],
			//当前页码
			pageIndex: 1,
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			dataForm: {
				recNo: '',
				monthlyRecNo: '',
				dataType: '',
				sourceId: '',
				sourceType: 0,
				sort: 0,
				fileName: '',
				updUserName: '',
				dataKind: '',
			},
			dataType: '',
			beginTime: '',
			endTime: '',
			title: '',
			fileIds: '',
			fileKind: '',
		};
	},
	methods: {
		init(monthlyRecNo, sort, dataType, fileKind, beginTime, endTime, fileIds) {
			this.dataType = dataType
			this.beginTime = beginTime
			this.endTime = endTime
			this.fileIds = fileIds
			this.fileKind = fileKind
			this.dataForm = {
				recNo: '',
				monthlyRecNo: monthlyRecNo,
				dataType: this.dataType,
				sourceId: '',
				sourceType: '',
				sort: sort,
				fileName: '',
				updUserName: $common.getItem("userName"),
				dataKind: '1',
			}
			// 标题
			if (fileKind == '1') {
				this.title = '监理联系单'
				this.getContactList()
			} else {
				this.title = '监理通知单'
				this.getNoticeList()
			}
			this.$nextTick(() => {
				this.subVisible = true;
			})
			this.pageIndex2 = 1;
		},
		// 获取数据列表
		getContactList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/supervisioncontactinfo/getWeeklyContactList",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					limit: this.pageSize,
					dataType: this.dataForm.dataType,
					monthlyRecNo: this.dataForm.monthlyRecNo,
					startTime: this.beginTime,
					completeTime: this.endTime,
					fileIds: this.fileIds,
					executedFileType: '2',
					workNo: $common.getItem("workNo"),
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				} else {
					this.dataList = []
					this.totalPage = 0
				}
			})
		},
		// 获取数据列表
		getNoticeList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/noticeinfo/getWeeklyNoticeList",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					limit: this.pageSize,
					dataType: this.dataForm.dataType,
					monthlyRecNo: this.dataForm.monthlyRecNo,
					startTime: this.beginTime,
					completeTime: this.endTime,
					fileIds: this.fileIds,
					executedFileType: '2',
					workNo: $common.getItem("workNo"),
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				} else {
					this.dataList = []
					this.totalPage = 0
				}
			})
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.getDataList();
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val;
			this.getDataList();
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVals.map((item) => item.fileId);
			if (checkIdList.includes(row.fileId)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
		handleSelectionChange(selection) {
			this.tableSelVals = selection;
			if (selection.length > 0) {
				this.disabledSaved = false;
			} else {
				this.disabledSaved = true;
			}
		},
		dataSubmit() {
			let sourceType = ''
			if (this.fileKind == '1') {
				// 联系单
				sourceType = '4'
			} else {
				// 通知单
				sourceType = '6'
			}
			let recordList = []
			for (var i = 0; i < this.tableSelVals.length; i++) {
				let record = {
					recNo: '',
					monthlyRecNo: this.dataForm.monthlyRecNo,
					dataType: this.dataType,
					sourceId: this.tableSelVals[i].fileId,
					sourceType: sourceType,
					sort: this.dataForm.sort + i,
					fileName: this.tableSelVals[i].weeklyContactDesc,
					dataKind: '1',
					updUserName: $common.getItem("userName"),
				}
				recordList.push(record)
			}
			let _url = "/business/projectmonthlyreportfile/saveBatchFileList";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recordList: recordList
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
		headClass() {
			return 'background:#E1F1FF;color:#00428E;border:solid #dadada 1px;padding:1px;font-size:12px'
		},
	}
};
</script>

<style scoped="scoped">
.kind_row {
	background-color: rgb(243, 247, 247);
	padding: 10px 0 10px 15px;
	margin-bottom: 10px;
	margin-top: -8px;
}

.kind_label {
	color: black !important;
	font-weight: bold !important;
}

.kind_value_left {
	color: #3471b6 !important;
	font-weight: bold !important;
	margin-left: 10px;
}

/* 穿透修改 dialog 头部样式 */
::v-deep .el-dialog__header {
	height: 50px !important;
	/* 固定高度30px */
	display: flex !important;
	/* 弹性布局 */
	align-items: center !important;
	/* 文字垂直居中 */
	padding: 0 10px !important;
	/* 清除原有内边距 */
	margin: 0 !important;
}

/* 标题文字样式保持不变 */
::v-deep .el-dialog__title {
	line-height: 30px !important;
	font-size: 14px;
}

::v-deep .el-dialog__headerbtn {
	top: 7% !important;
	transform: translateY(-60%) !important;
	/* 把 -50% 改成 -60% 就往上移了 */
}
</style>
